<template>
    <modal :title="title" :id="id" :actionButtons="true" size="lg" scrollable @shown="shown" @hidden="hidden">
        <div :style="teamIds.length > 1 ? 'min-height: 800px' : ''">
            <div v-if="teamIds.length > 1" class="row">
                <div class="col-12 mb-2">
                    <team-select v-model="teamFilter"
                                 :params="teamParams"
                                 :placeholder="$t('Select a team member to checkout only his treatments')" id-only
                                 mode="tree"
                                 multiple
                    ></team-select>
                </div>
            </div>
            <div v-if="cartItems.length" class="row align-items-top">
                <div v-for="(item, index) in cartItems" :key="index" class="col-12">
                    <div class="card border border mb-2">
                        <div class="card-body p-2">
                            <div class="row align-items-center">
                                <div class="col-7 col-sm-auto">
                                    <div class="d-flex flex-row align-items-baseline"><h4 class="card-title mb-1">{{ item.treatments.label }}</h4>&nbsp;
                                        <span class="text-muted">
                                        (<money class="text-muted text-body" :value="item.treatments.price"></money>)
                                    </span>
                                    </div>
                                    <p class="card-text small text-muted mb-1">{{ item.treatments.description }}</p>
                                    <span class="text-muted">
                                    {{ item.user.firstName }}
                                    {{ item.user.lastName }}
                                </span>
                                    <div class="h3 m-0">{{ item.tooths.join(', ') }}</div>
                                </div>
                                <div class="col d-none d-sm-block"></div>
                                <div class="col-5 col-sm-auto">
                                    <div class="row m-0 text-right">
                                        <div class="col-12 col-sm">
                                            <money :value="item.treatments.price * item.quantity "/>
                                        </div>
                                        <div class="col-12 col-sm-auto">
                                            <confirmable-button button-class="btn btn-white btn-sm" @confirm="removeFromCart(item._id)">
                                                <i class="fe fe-trash"></i>
                                            </confirmable-button>
                                        </div>
                                    </div>
                                </div>
                            </div>
                        </div>
                    </div>
                </div>
            </div>
            <div v-else class="row">
                <div class="col">{{ $t('Do you want to checkout?') }}</div>
            </div>
        </div>
        <template slot="modal-footer">
            <div class="card-footer" style="display:block">
                <div class="row">
                    <div class="col"></div>
                    <div class="col-auto">
                        <button type="button" @click="close" class="btn btn-white">{{ $t('Close') }}</button>
                    </div>
                    <div class="col-auto">
                        <button type="button" @click="confirmed" class="btn btn-primary">{{ $t('Confirm') }}</button>
                    </div>
                </div>
            </div>
        </template>
    </modal>
</template>

<script>
import Modal from "@/components/Modal.vue";
import Money from "@/components/Money.vue";
import { mapActions, mapGetters, mapState } from "vuex";
import { modalMixins } from "@/mixins/modal.js";
import TeamFilter from "@/components/TeamFilter";
import TeamSelect from "@/components/TeamSelect";
import ConfirmableButton from "@/components/ConfirmableButton";

export default {
    name: "ExpressCheckoutModal",
    props: ["id", "customerId"],
    mixins: [modalMixins],
    components: {
        ConfirmableButton,
        TeamSelect,
        TeamFilter,
        Modal,
        Money
    },
    computed: {
        ...mapGetters("appointment", { findDataInStore: "find" }),
        ...mapGetters("cart", { getCustomerCart: "find" }),

        appointments() {
            return this.findDataInStore({ query: this.unfinishedQuery() }).data;
        },

        cartItems() {
            let query = { customerId: this.customerId }
            if (this.teamFilter.length)
                query.userId = { $in: this.teamFilter }
            return this.getCustomerCart({ query }).data;
        },

        teamIds() {
            let query = { customerId: this.customerId }
            return Object.keys(this.$groupBy(this.getCustomerCart({ query }).data, item => item.userId))
        },

        teamParams() {
            return { query: { _id: { $in: this.teamIds } } }
        }
    },
    data() {
        return {
            title: this.$t("Checkout"),
            teamFilter: []
        };
    },
    created() {
    },

    methods: {
        ...mapActions("appointment", {
            createAppointment: "create",
            fetch: "find"
        }),
        ...mapActions("cart", { fetchCustomerCart: "find", removeFromCart: 'remove' }),
        ...mapActions("customers", { fetchCustomer: "get" }),


        fetchUnfinished() {
            return this.fetch({ query: this.unfinishedQuery() });
        },

        unfinishedQuery() {
            return {
                $limit: 1,
                $sort: { startAt: -1 },
                status: { $nin: ["cancelled", "completed"] },
                customerId: this.customerId,
                startAt: { $lte: this.$moment(), $gte: this.$moment().startOf("day") }
            };
        },

        shown() {
            this.fetchUnfinished();
            this.teamFilter = []
            this.fetchCustomerCart({ query: { customerId: this.customerId } });
        },

        hidden() {
            this.teamFilter = []
        },

        confirmed() {
            if (this.appointments.length >= 1) {
                this.openCheckoutModal(this.appointments[0], { teamIds: this.teamFilter });
            } else {
                let data = {
                    startAt: this.$moment().subtract('30', 'minutes'),
                    endAt: this.$moment(),
                    services: [],
                    customerId: this.customerId
                };
                if (this.teamFilter.length) {
                    this.fetchCustomer(this.customerId).then(customer => {
                        data.customer = customer
                        this.openCheckoutModal(data, { teamIds: this.teamFilter })
                    })
                } else {
                    this.createAppointment(data).then(result => {
                        this.openCheckoutModal(result);
                    });
                }
            }
            this.close();
        },

        validation(field) {
            if (this.errors && this.errors[field]) return false;
            else return null;
        },

        close() {
            this.$root.$emit("bv::hide::modal", this.id);
        }
    }
};
</script>
